import React from 'react';
import { useSelector } from 'react-redux';
import './_styles_/DBGLoginLink.css';
import { getPublicConfig } from '../reducers';
import Constants from '../utils/Constants';

function DBGLoginLink() {
    const publicConfig = useSelector(getPublicConfig);
    if (publicConfig.ssoEnabled) {
        const loginUrl = new URL(publicConfig.dbgLoginURL);
        loginUrl.searchParams.append('scope', 'openid profile');
        loginUrl.searchParams.append('response_type', 'code');
        loginUrl.searchParams.append('client_id', publicConfig.dbgLoginClientID);
        loginUrl.searchParams.append('redirect_uri', Constants.REDIRECT_URI.href);
        return (
            <a href={loginUrl.href} className="dbg-login-link">
                <span className="dbg-login-link--text">Login using DBG account</span>
            </a>
        );
    }
    return null;
}

export default DBGLoginLink;
